module.exports = __webpack_public_path__ + "img/role1.532d6870.png";